﻿export const videoLoaderState = function ({
	settings,
}) {
	return {
		settings,
		loaded: false,
		setupComponent: function () {

		},

		LoadVideo: async function () {
			if (this.loaded) return;
			this.settings.ShowSpinner = true;
			try {
				await $.ajax({
					type: 'GET',
					url: this.settings.Url,
					headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
					success: function (response) {
						$('#' + settings.ElementId).html(response);
					}
				});
			} catch (error) {
				$('#' + this.settings.ErrorElementId).html(this.settings.ErrorMessage);
			}
			this.settings.ShowSpinner = false;
			this.loaded = true;
		},

		ShowSpinner: function () {
			return this.settings.ShowSpinner;
		},

		IsOpen: function () {
			return this.settings.IsOpen;
		},

		ToggleOpen: function () {
			this.settings.IsOpen = !this.settings.IsOpen;
		}
	}
}